/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Files_FoldersInputs */

const en_files_folders = /** @type {(inputs: Files_FoldersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Folders`)
};

const es_files_folders = /** @type {(inputs: Files_FoldersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Carpetas`)
};

/**
* | output |
* | --- |
* | "Folders" |
*
* @param {Files_FoldersInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const files_folders = /** @type {((inputs?: Files_FoldersInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Files_FoldersInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_files_folders(inputs)
	return en_files_folders(inputs)
});